import { GetShadefinderQueryQuery } from '@notino/shared/definitions/types';

import {
  ShadefinderShadesKeys,
  ShadefinderDesiredShade,
  ShadefinderDesiredShadeKeys,
  ShadefinderShadeUndertoneKeys,
  ShadefinderShadeUndertone,
} from '../../types';

/**
 * Returns only desired shades that have at least one product
 * @param desiredShade
 */
function onlyDesiredShadesWithExistingProduct(
  desiredShade: ShadefinderDesiredShade
) {
  return Object.keys(desiredShade).reduce((acc, key) => {
    if (key === '__typename') {
      return acc;
    }
    const recommendedProduct = desiredShade[key as ShadefinderDesiredShadeKeys];

    if (recommendedProduct?.productId) {
      return { ...acc, [key]: recommendedProduct };
    }

    return acc;
  }, {} as typeof desiredShade);
}

/**
 * Returns only undertones that have at least one desired shade
 * @param undertones
 */
function onlyUndertonesWithExistingDesiredShades(
  undertones: ShadefinderShadeUndertone
) {
  return Object.keys(undertones).reduce((acc, key) => {
    if (key === '__typename') {
      return acc;
    }

    const desiredShade = undertones[key as ShadefinderShadeUndertoneKeys];

    if (desiredShade) {
      const newDesiredShade =
        onlyDesiredShadesWithExistingProduct(desiredShade);

      return { ...acc, [key]: newDesiredShade };
    }

    return acc;
  }, {} as typeof undertones);
}

/**
 * Returns only shades that have at least one undertone and the undertone has at least one desired shade
 * @param shade
 */
function onlyShadesWithExistingUndertones(
  shade: NonNullable<GetShadefinderQueryQuery['getShadefinder']>['shades']
) {
  return Object.keys(shade).reduce((acc, key) => {
    if (key === '__typename') {
      return acc;
    }
    const undertones: ShadefinderShadeUndertone =
      shade[key as keyof ShadefinderShadesKeys];

    if (undertones) {
      const newUndertones = onlyUndertonesWithExistingDesiredShades(undertones);

      return { ...acc, [key]: newUndertones };
    }
    return acc;
  }, {} as NonNullable<GetShadefinderQueryQuery['getShadefinder']>['shades']);
}

export { onlyShadesWithExistingUndertones };
